var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgElectricMoped = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17 3c1.1 0 2 .9 2 2v3.35L14.48 14H10c0 1.66-1.34 3-3 3s-3-1.34-3-3H2v-3c0-2.21 1.79-4 4-4h4v5h3.52L17 7.65V5h-3V3h3ZM4 11v1h4V9H6c-1.1 0-2 .9-2 2Zm2 3c0 .55.45 1 1 1s1-.45 1-1H6ZM5 4h5v2H5V4Zm14 7c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3Zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1Zm-8 5H7l6 3v-2h4l-6-3v2Z",
  fill: "#1A1A1A"
})));
export default SvgElectricMoped;